let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("fVZub")).then(() => parcelRequire('jYfQG'));